export default "__VITE_ASSET__2EkedMWA__"